import {
  INITIAL_PRACTITIONERS_LOADING,
  INITIAL_PRACTITIONERS_SUCCESS,
  INITIAL_PRACTITIONERS_FAILED,

  SEARCH_PRACTITIONERS_LOADING,
  SEARCH_PRACTITIONERS_SUCCESS,
  SEARCH_PRACTITIONERS_FAILED,

  GET_OTHER_PRACTITIONERS_LOADING,
  GET_OTHER_PRACTITIONERS_SUCCESS,
  GET_OTHER_PRACTITIONERS_FAILED,

  UPDATE_OTHER_PRACTITIONERS_LOADING,
  UPDATE_OTHER_PRACTITIONERS_SUCCESS,
  UPDATE_OTHER_PRACTITIONERS_FAILED,

  ADD_CLINIC_LOADING,
  ADD_CLINIC_SUCCESS,
  ADD_CLINIC_FAILED,

  ADD_PRACTITIONER_LOADING,
  ADD_PRACTITIONER_SUCCESS,
  ADD_PRACTITIONER_FAILED,

  EDIT_CLINIC_LOADING,
  EDIT_CLINIC_SUCCESS,
  EDIT_CLINIC_FAILED,

  DELETE_PRACTITIONER_LOADING,
  DELETE_PRACTITIONER_SUCCESS,
  DELETE_PRACTITIONER_FAILED,

  CLEAR_SEARCH

} from '../actions/submitPractitionerActions'

const submitPractitioner = (state = {
  isLoading: false,
  initialPractitioners: null,
  error: null,
  practitioners: null
}, action) => {
  switch (action.type) {
    case INITIAL_PRACTITIONERS_LOADING:
      return Object.assign({}, state, {
        isLoading: true,
        initialPractitioners: null,
        error: null
      })
    case INITIAL_PRACTITIONERS_SUCCESS:
      return Object.assign({}, state, {
        isLoading: false,
        initialPractitioners: action.response,
        error: null
      })
    case INITIAL_PRACTITIONERS_FAILED:
      return Object.assign({}, state, {
        isLoading: false,
        initialPractitioners: null,
        error: action.error
      })
    case SEARCH_PRACTITIONERS_LOADING:
      return Object.assign({}, state, {
        isLoading: true,
        practitioners: null,
        error: null
      })
    case SEARCH_PRACTITIONERS_SUCCESS:
      return Object.assign({}, state, {
        isLoading: false,
        practitioners: action.response,
        error: null
      })
    case SEARCH_PRACTITIONERS_FAILED:
      return Object.assign({}, state, {
        isLoading: false,
        practitioners: null,
        error: action.error
      })
      // other extended health
    case GET_OTHER_PRACTITIONERS_LOADING:
      return Object.assign({}, state, {
        isLoading: true,
        otherPractitioners: null,
        error: null
      })
    case GET_OTHER_PRACTITIONERS_SUCCESS:
      return Object.assign({}, state, {
        isLoading: false,
        otherPractitioners: action.response,
        error: null
      })
    case GET_OTHER_PRACTITIONERS_FAILED:
      return Object.assign({}, state, {
        isLoading: false,
        otherPractitioners: null,
        error: action.error
      })
    case UPDATE_OTHER_PRACTITIONERS_LOADING:
      return Object.assign({}, state, {
        isLoading: true,
        otherPractitioners: null,
        error: null
      })
    case UPDATE_OTHER_PRACTITIONERS_SUCCESS:
      return Object.assign({}, state, {
        isLoading: false,
        otherPractitioners: action.response,
        error: null
      })
    case UPDATE_OTHER_PRACTITIONERS_FAILED:
      return Object.assign({}, state, {
        isLoading: false,
        otherPractitioners: null,
        error: action.error
      })
    case ADD_CLINIC_LOADING:
      return Object.assign({}, state, {
        clinicLoading: true,
        clinicResponse: null,
        clinicError: null
      })
    case ADD_CLINIC_SUCCESS:
      return Object.assign({}, state, {
        clinicLoading: false,
        clinicResponse: action.response,
        clinicError: null
      })
    case ADD_CLINIC_FAILED:
      return Object.assign({}, state, {
        clinicLoading: false,
        clinicResponse: null,
        clinicError: action.error
      })

    case ADD_PRACTITIONER_LOADING:
      return Object.assign({}, state, {
        pracLoading: true,
        pracResponse: null,
        pracError: null
      })
    case ADD_PRACTITIONER_SUCCESS:
      return Object.assign({}, state, {
        pracLoading: false,
        pracResponse: action.response,
        pracError: null
      })
    case ADD_PRACTITIONER_FAILED:
      return Object.assign({}, state, {
        pracLoading: false,
        pracResponse: null,
        pracError: action.error
      })
    case EDIT_CLINIC_LOADING:
      return Object.assign({}, state, {
        eclinicLoading: true,
        eclinicResponse: null,
        eclinicError: null
      })
    case EDIT_CLINIC_SUCCESS:
      return Object.assign({}, state, {
        eclinicLoading: false,
        eclinicResponse: action.response,
        eclinicError: null
      })
    case EDIT_CLINIC_FAILED:
      return Object.assign({}, state, {
        eclinicLoading: false,
        eclinicResponse: null,
        eclinicError: action.error
      })
    case DELETE_PRACTITIONER_LOADING:
      return Object.assign({}, state, {
        isLoading: true,
        deleteError: null
      })
    case DELETE_PRACTITIONER_SUCCESS:
      return Object.assign({}, state, {
        isLoading: false,
        deleteError: null
      })
    case DELETE_PRACTITIONER_FAILED:
      return Object.assign({}, state, {
        isLoading: false,
        deleteError: action.error
      })
    case CLEAR_SEARCH:
      return Object.assign({}, state, {
        practitioners: null
      })
    default:
      return state
  }
}

export default submitPractitioner



// WEBPACK FOOTER //
// ./src/redux/reducers/submitPractitionerReducer.js